import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteFile(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteFile = (fileId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`files/${fileId}/`);
  };

  return useMutation(deleteFile, {
    onSuccess: () => {
      queryClient.removeQueries('files');
    },
  });
}
